<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.aside.geo', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb :text="text"></portal-breadcumb>
      <div style="height: 100%" class="geo-content">
        <portal-geo-filter v-on:filter="reloadMap"></portal-geo-filter>
        <l-map :zoom="zoom" :center="center" :options="{ zoomControl: false }">
          <!-- <l-control :position="'topright'" class="legend">
            <p>
              <i style="background: #948a87" class="round"></i>
              <span>{{
                $t("message.maintenance.workshops", { value: "default" })
              }}</span>
            </p>

            <p>
              <i style="background: #7fc7b2" class="square"></i>
              <span>{{
                $t("message.page.available", { value: "default" })
              }}</span>
            </p>

            <p>
              <i style="background: #eebb07" class="square"></i>
              <span>{{
                $t("message.page.maintenance", { value: "default" })
              }}</span>
            </p>
          </l-control> -->
          <l-tile-layer :url="url"></l-tile-layer>
          <l-circle-marker
            v-for="poi in poiList"
            :key="poi.poinum"
            :lat-lng="latLngPoi(poi)"
            :radius="6"
            :fill="true"
            :color="gColor"
            :fillColor="gColor"
            :fillOpacity="1"
          >
            <l-tooltip class="tooltip2"
              >{{ poi.poiname }} <br />
              <h3>{{ poi.city }}</h3>
            </l-tooltip>
          </l-circle-marker>
          <template v-if="!itinerary">
            <l-marker
              v-for="(point, idx) in positions"
              :key="idx"
              :lat-lng="latLng(point)"
            >
              <l-icon class-name="someExtraClass">
                <v-chip
                  label
                  :color="getColor(point.asset.status)"
                  dark
                  style="font-size: bold bold bold 12px Calibri"
                  >{{ point.locomotive.locomotive }}</v-chip
                >
                <!-- <v-btn icon plain color="#EEBB07">
                  <v-icon dense dark> mdi-magnify-plus </v-icon>
                </v-btn>-->

                <!--<v-badge
                  bordered
                  color="#EEBB07"
                  icon="mdi-magnify-plus"
                ></v-badge>-->
              </l-icon>
              <l-tooltip :options="{ opacity: 1 }" class-name="myT">
                <portal-geo-tooltip :point="point"></portal-geo-tooltip>
              </l-tooltip>
            </l-marker>
          </template>

          <l-polyline
            v-if="itinerary"
            :lat-lngs="polyline.latlngs"
            :color="polyline.color"
          ></l-polyline>
          <l-marker v-if="itinerary" :lat-lng="getActualPosition()" />

          <l-control-zoom position="topright"></l-control-zoom>
        </l-map>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import PortalGeoFilter from "@/components/PortalGeoFilter.vue";
import PortalGeoTooltip from "@/components/PortalGeoTooltip.vue";
import { mapGetters, mapActions } from "vuex";
import CascService from "@/services/CascService";
import CoreService from "@/services/CoreService";
import { getNewPayloadList } from "@/shared/LocoMixin";
//import { firstDateOfCurrentMonth, currentDate } from "@/shared/DateHelper";
import MaximoService from "@/services/MaximoService";
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LControlZoom,
  //LControl,
  LPolyline,
  LIcon,
  LCircleMarker,
} from "vue2-leaflet";
import L from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  title: "Geolocate my equipement",
  methods: {
    ...mapActions("customer", {
      actionGetLocos: "loadLocos",
    }),

    loadLocos() {},

    latLng(point) {
      return [point.locomotive.latitude, point.locomotive.longitude];
    },

    loadPoi() {
      CoreService.findAll().then((response) => {
        this.poiList = response.data;
      });
    },

    latLngPoi(poi) {
      return [poi.latitude, poi.longitude];
    },

    async lastPosition() {
      MaximoService.loadLeasingAssset(this.getterCurrentClient)
        .then((response) => {
          this.dispoLoc = response.data;
          //CascService.lastPositionAndBatteryLevelForCustomer({
          CascService.lastPositionAndBatteryLevelAndFuellevelForCustomer({  
            clients: [this.getterCurrentClient],
            locomotives: getNewPayloadList(this.dispoLoc),
          }).then((response) => {
            this.positions = this.getStatuts(response.data, this.dispoLoc);
          });
        })
        .catch(() => {
          this.dispoLoc = [];
        });
    },

    getStatuts(data, locos) {
      let list = [];
      var i;
      for (i = 0; i < data.length; i++) {
        let find = locos.find((e) => e.assetnum == data[i].locomotive);
        list.push({
          locomotive: data[i],
          asset: find === undefined ? "" : find,
        });
      }
      return list;
    },

    getActualPosition() {
      var point = this.polyline.latlngs[this.polyline.latlngs.length - 1];
      return [point[0], point[1]];
    },

    getColor(value) {
      if (this.availableStatus.includes(value)) {
        return "#5dea4c";
      } else if (value == "MAINTENANCE") {
        return "#EEBB07";
      }
      return "#df0024";
    },

    extractLatLngs(data) {
      let latLngs = [];
      for (var i = 0; i < data.length; i++) {
        latLngs.push([data[i].latitude, data[i].longitude]);
      }
      return latLngs;
    },

    reloadMap(payload) {
      if (payload.locomotives != null) {
        if (payload.locomotives.length == 1) {
          this.itinerary = true;
          CascService.geolocs(payload).then((response) => {
            this.polyline.latlngs = this.extractLatLngs(response.data);
          });
        } else {
          this.itinerary = false;
          CascService.lastPosition(payload).then((response) => {
            this.positions = response.data;
          });
        }
      } else {
        this.itinerary = false;
        CascService.lastPosition(payload).then((response) => {
          this.positions = response.data;
        });
      }
    },
  },
  name: "GeolocPage",
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    LControlZoom,
    //LControl,
    LCircleMarker,
    PortalGeoFilter,
    LPolyline,
    PortalGeoTooltip,
  },
  data: () => ({
    poiList: [],
    dispoLoc: [],
    availableStatus: [
      "OPERATING",
      "ACTIVE",
      "WARNING",
      "LIMITED USED",
      "CONDREL",
    ],
    title: "GEOLOCALISER MON MATERIEL",
    text: "Acceuil > Mon planning > Geolocaliser mon materiel",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    zoom: 6,
    center: [47.31322, -1.319482],
    markerLatLng: [47.31322, -1.319482],
    locoList: [],
    positions: [],
    staticAnchor: [16, 37],
    itinerary: false,
    yColor: "#EEBB07",
    gColor: "#948a87",
    polyline: {
      latlngs: [],
      color: "#EEBB07",
    },
  }),

  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
    }),
    ...mapGetters("customer", {
      getterCustomer: "getCustomer",
      getterTeams: "getTeams",
      getterLocos: "getLocos",
    }),
  },

  mounted() {
    this.lastPosition();
    this.loadPoi();
  },
};
</script>

<style>
.someExtraClass {
  text-align: center;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  font-weight: bolder;
}

.tooltip {
  padding: 0px;
  border: unset;
}

.myT {
  padding: 0px;
  border: 1px #000;
  background: #000;
}

.tooltip2 {
  color: #00475a;
  font-size: 14px;
  font-family: Calibri;
  margin: 0px;
  padding: 10px;
}

.legend {
  padding: 6px 8px;
  font: 14px Arial, Helvetica, sans-serif;
  background: white;
  background: rgba(255, 255, 255, 1);
  /*box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);*/
  /*border-radius: 5px;*/
  line-height: 24px;
  color: #555;
}

.round {
  width: 18px;
  height: 18px;
  float: left;
  margin: 0 8px 0 0;
  opacity: 0.7;
  border-radius: 10px;
}

.square {
  width: 18px;
  height: 18px;
  float: left;
  margin: 0 8px 0 0;
  opacity: 0.7;
}

.legend span {
  position: relative;
  bottom: 3px;
}
</style>
